import React from "react"
import { TaskStatus } from "../../../../../../Models/API/TaskModel"
import { Pill } from "dash-styled"

interface Props {
    status: TaskStatus
    correct?: boolean
    className?: string
    size?: "sm" | "md" | "lg"
}

export const TaskStatusPill: React.FC<Props> = ({
    status,
    correct,
    className,
    size
}: Props) => {
    const cls = `whitespace-no-wrap ${className ?? ""} ${
        size === "sm" ? "w-24" : "w-32"
    }`

    switch (status) {
        case TaskStatus.COMPLETED:
            if (correct !== undefined) {
                return correct ? (
                    <Pill
                        state="correct"
                        label="Correct"
                        className={cls}
                        testId="correct-pill"
                        size={size}
                    />
                ) : (
                    <Pill
                        state="incorrect"
                        label="Incorrect"
                        className={cls}
                        testId="incorrect-pill"
                        size={size}
                    />
                )
            }
            return (
                <Pill
                    state="complete"
                    label="Complete"
                    className={cls}
                    testId="complete-pill"
                    size={size}
                />
            )
        case TaskStatus.CANCELED:
            return (
                <Pill
                    bgColor="black"
                    state="canceled"
                    label="Canceled"
                    className={cls}
                    testId="canceled-pill"
                    size={size}
                />
            )
        case TaskStatus.IN_PROGRESS:
            return (
                <Pill
                    bgColor="gray"
                    state="in-progress"
                    label="In Progress"
                    className={cls}
                    testId="progress-pill"
                    size={size}
                />
            )
        case TaskStatus.SCHEDULED:
            return (
                <Pill
                    bgColor="lightgray"
                    state="scheduled"
                    label="Queued"
                    className={cls}
                    testId="queued-pill"
                    size={size}
                />
            )
    }
}
